export const Benefits =
    [
        <>Empfohlen vom Regionalmanagement Mittelhessen <a target="_blank" href="https://mittelhessen.app/">Mehr dazu</a></>,
        <>Empfohlen von unseren Kommunen <a target="_blank" href="https://mittelhessen.app/kommunen">Mehr dazu</a></>,
        <>Über 200 Firmen, Vereine & Co. sind schon dabei</>,
        <>Diverse Apps für 1.041.271 Einwohnende (zzgl. Tourismus)</>,
        <>Regelmäßige Updates</>,
        <>Top Support & zahlreiche <a target="_blank" href="https://blog.dashdesign.eu/">Anleitungen</a></>,
    ]
